
const TermCondition = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}

      {/* Main Content */}
      <main className="max-w-5xl mx-auto px-4 py-8 mt-24">
        <div className="bg-white rounded-lg shadow-md p-6 md:p-8">
          <div className="space-y-6">
            {/* Effective Date */}
            <p className="text-sm text-gray-600">Last Updated: 15-Jan-25</p>

            {/* Introduction */}
            <section className="space-y-4">
              <h2 className="text-gray-700 leading-relaxed">
              Welcome to Pixell | Signthought Solutions Private Limited (“we,” “our,” or “us”). By accessing and using our website www.pixell.in (the "Website"), you agree to be bound by these Terms of Use (“Terms”). If you do not agree to these Terms, please do not use our Website.
              </h2>
            </section>

            {/* Information Collection */}
            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">
              1. Use of Website
              </h2>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>
                You must be at least 18 years old or have parental consent to use our Website.
                </li>
                <li>
                You agree not to misuse the Website, including attempting unauthorized access or interfering with its functionality.
                </li>
                
              </ul>
            </section>

            {/* Information Usage */}
            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">
              2. Intellectual Property
              </h2>
            
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>All content on the Website, including text, images, logos, and designs, is owned by or licensed to Signthought Solutions Private Limited. Unauthorized use, reproduction, or distribution is prohibited</li>
              </ul>
            </section>

            {/* Information Sharing */}
            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">
              3. User Conduct
              </h2>
            
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>
                You must not engage in activities that violate any laws or harm our Website, including spreading malware, spamming, or violating intellectual property rights.
                </li>
            
              </ul>
            </section>

            {/* Security */}
            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">
              4. Disclaimer & Limitation of Liability
              </h2>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>
                The Website and its content are provided "as is" without warranties of any kind.
                                </li>
                                <li>
                                We are not responsible for any damages arising from the use of our Website.
                                </li>
              </ul>
            </section>

            {/* Privacy Rights */}
            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">
              5. Changes to Terms
              </h2>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>
                We may update these Terms from time to time. Continued use of the Website after changes are posted means you accept the updated Terms.
                </li>
              
              </ul>
            </section>

            {/* Changes */}
            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">
              6. Governing Law
              </h2>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>
                These Terms are governed by the laws of India.                </li>
              
              </ul>
            </section>

            {/* Contact */}
            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">
                7. Contact Us
              </h2>
              <p className="text-gray-700">
              If you have any questions about these Terms, please contact us at support@pixell.in
              </p>
            
            </section>

        
          </div>
        </div>
      </main>
    </div>
  );
};

export default TermCondition;
